// extracted by mini-css-extract-plugin
export default {"titleText":"Text_titleText__Wrk7h","subText":"Text_subText__vcEca","bodyText":"Text_bodyText__GCqqr","mediumTitle":"Text_mediumTitle__WGT9Z"};